module.exports = __webpack_public_path__ + "img/tooltip_06-vallone-aure-wood-rovere-nordic.f0969dff.jpg";